
export default {
  /*站点配置缓存 */
  siteconfigKey:'__xr_siteconfig',  
  addSiteconfig : function(sc){
    this.delSiteconfig()
    if(typeof(sc) == "object"){
      sc = JSON.stringify(sc)
    }
    window.localStorage.setItem(this.siteconfigKey, sc)
  },
  getSiteconfig : function(){
    var sc = window.localStorage.getItem(this.siteconfigKey)
    if(sc){
      return JSON.parse(sc)
    }
    return {}
  },
  delSiteconfig : function(){
    return window.localStorage.removeItem(this.siteconfigKey)
  }
}



// WEBPACK FOOTER //
// ./src/util/siteconfigCache.js